import React from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { colors, spacing } from '../../lib/theme';
import { playAudioBool, playNextAudioAction, pauseAudio, saveEpisodesToPlay, addToAutoQueueInfo, seekAudioToProgress, setEpisodeProgress } from '../../actions';
import { maxDuration } from '../../actions/AppAudio';

import {
    CaretRightFilled,
    PauseCircleTwoTone,
    PauseOutlined,
    PlayCircleTwoTone,
    // setTwoToneColor,
} from '@ant-design/icons';

import { Button, notification } from 'antd';
import { getTrailerData } from '../../lib/fileUtils';

// setTwoToneColor(colors.primary);
// class PlayMain extends React.Component {
class PlayMain extends React.PureComponent {
    onPlayClick(audioInfoNew) {
        const { episodesToPlay, userDetails, addToAutoQueueInfoFn, playlistId, startSec, startSlider, audioInfo, podcastEpisode } = this.props;
        // const { audioInfo } = this.props.audioState;
        // const audioInfo = this.props.audioInfo;

        if (!audioInfoNew.guid) {
            notification['error']({
                message: 'Invalid url.',
                description: 'This episode can\'t be played',
                duration: null
            });
        }

        if (startSlider != null) {
            if (!userDetails || !userDetails.uid) {
                notification['info']({
                    // message: 'Regist.',
                    description: 'Please sign in or register to play an auto chapter.',
                    duration: null
                });
                return;
            }
            // Future.delayed(const Duration(milliseconds: 500), () {
            // utils.printLog('startSlider');
            // utils.printLog(startSlider);
            // PodcastEpisode ? audioInfo = vm.audioState;
            if (audioInfo != null &&
                audioInfo.guid &&
                podcastEpisode.guid &&
                (audioInfo.guid == podcastEpisode.guid)) {
                console.dir('startSlider2')
                // utils.printLog('startSlider2');
                const startSliderAccurate =
                    (100 * (startSec || 0) / (maxDuration || 3600));
                console.dir(startSliderAccurate)
                //// use this as it's more accurate as maxDuration can change compared to autoChapter value
                this.props.seekAudioToProgressFn(
                    maxDuration ? startSliderAccurate : startSlider, true);
            } else {
                const trailerData = getTrailerData();
                let startSliderAccurate;
                if (trailerData[audioInfoNew.guid]) {
                    // utils.printLog('startSlider3.01');
                    startSliderAccurate = (100 *
                        (startSec || 0) / (trailerData[audioInfoNew.guid] ?? 3600));
                }
                // utils.printLog('startSlider3');
                console.dir('startSlider3')
                console.dir(startSliderAccurate)
                console.dir(startSlider)
                this.props.setEpisodeProgress(
                    userDetails.uid, audioInfoNew, startSliderAccurate || startSlider);
            }
            // });
        }
        this.props.playNextAudioAction(audioInfoNew);
        /// TODO: save next episodes queue here
        /// save only the episodes which are after this episode
        console.dir(episodesToPlay);
        if (episodesToPlay && episodesToPlay.length > 0) {
            let currEpisodeIndex = episodesToPlay.findIndex((el) => el?.guid == audioInfoNew?.guid);
            console.dir(currEpisodeIndex);
            console.dir(playlistId);
            if (currEpisodeIndex >= 0 && currEpisodeIndex < episodesToPlay.length - 1) {
                let nextEpisodesList =
                    episodesToPlay.slice(currEpisodeIndex + 1);

                console.dir('playlistId onPlayClickCode: ');
                console.dir(playlistId);
                if (playlistId != null && playlistId) {
                    addToAutoQueueInfoFn(nextEpisodesList, playlistId);
                } else {
                    addToAutoQueueInfoFn(nextEpisodesList, '');
                }


                // saveEpisodesToPlay(nextEpisodesList);
            }
        }


        // this.props.sendAudioInfo(audioInfoNew, (podcastEpisodes && podcastEpisodes.items) || []);
        // this.props.playAudioBool(true, audioInfoNew.guid);
        // if (typeof userDetails !== 'undefined' && userDetails && typeof userDetails.uid !== 'undefined') {
        //     if (((!audioInfo || !audioInfo.guid) && audioInfoNew.guid) || ((audioInfo && audioInfo.guid) !== audioInfoNew.guid)) {
        //         this.props.addEpisodeToRecent(userDetails.uid, audioInfoNew);
        //     }
        // }
    }

    onPauseClick() {
        // this.props.playAudioBool(false);
        this.props.pauseAudio();
    }

    render() {
        const { podcastEpisode, iconType, audioInfo, currentlyPlayingFromChapter } = this.props;
        // const { audioInfo, playAudio, currentEpisodeId } = this.props.audioState;
        // const audioInfo = this.props.audioInfo;
        const { playAudio } = this.props.audioPlayState;
        let currentlyPlaying = (audioInfo && audioInfo.guid == podcastEpisode.guid); // || (currentEpisodeId == podcastEpisode.guid);
        // console.dir(currentlyPlaying);
        const fontSize = '24px';
        let iconDomPlay;
        let iconDomPause;
        if (iconType == 'twoTone') {
            iconDomPlay = (<PlayCircleTwoTone style={{ fontSize: fontSize, color: '#000' }} />);
            iconDomPause = (<PauseCircleTwoTone style={{ fontSize: fontSize, color: '#000' }} />);
        } else {
            iconDomPlay = (<CaretRightFilled style={{ fontSize: fontSize, color: '#000' }} />);
            iconDomPause = (<PauseOutlined style={{ fontSize: fontSize, color: '#000' }} />);
        }
        if (currentlyPlayingFromChapter != null) {
            currentlyPlaying = currentlyPlayingFromChapter;
        }
        return <>
            {iconType === 'button' ?
                <div>
                    {(!currentlyPlaying || (currentlyPlaying && !playAudio)) && <Button style={{ width: '100%', height: '2.75em' }}
                        type='primary' onClick={this.onPlayClick.bind(this, podcastEpisode)}><CaretRightFilled style={{ fontSize: fontSize }} />
                        <span style={{ transform: 'translate(0, -0.25em)' }}>Play</span></Button>
                    }
                    {(currentlyPlaying && playAudio) && <Button style={{ width: '100%', height: '2.75em' }}
                        type='primary' onClick={this.onPauseClick.bind(this)}><PauseOutlined style={{ fontSize: fontSize }} />
                        <span style={{ transform: 'translate(0, -0.25em)' }}>Pause</span></Button>
                    }
                </div> :
                <div style={{ display: 'inline' }}>
                    <a onClick={this.onPlayClick.bind(this, podcastEpisode)}>
                        {!currentlyPlaying && iconDomPlay}
                        {currentlyPlaying && !playAudio && iconDomPlay}
                    </a>
                    <a onClick={this.onPauseClick.bind(this)}>
                        {currentlyPlaying && playAudio && iconDomPause}
                    </a>
                </div>
            }
        </>;
    }
}

PlayMain.propTypes = {
    // audioState: PropTypes.object,
    userDetails: PropTypes.object,
    podcastEpisode: PropTypes.object,
    iconType: PropTypes.string,
    playlistId: PropTypes.string,
    // sendAudioInfo: PropTypes.func,
    // playAudioBool: PropTypes.func,
    // addEpisodeToRecent: PropTypes.func,
    playNextAudioAction: PropTypes.func,
    pauseAudio: PropTypes.func,
    currentlyPlayingFromChapter: PropTypes.bool,
    // podcastEpisodes: PropTypes.object,
    audioInfo: PropTypes.object,
    audioPlayState: PropTypes.object,
    episodesToPlay: PropTypes.array,
    addToAutoQueueInfoFn: PropTypes.func,
    seekAudioToProgressFn: PropTypes.func,
    setEpisodeProgress: PropTypes.func,
    startSlider: PropTypes.number,
    startSec: PropTypes.number,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        // audioState: state.audioState,
        audioInfo: state.audioState || {},
        audioPlayState: state.audioPlayState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // sendAudioInfo: bindActionCreators(sendAudioInfo, dispatch),
        // playAudioBool: bindActionCreators(playAudioBool, dispatch),
        playNextAudioAction: bindActionCreators(playNextAudioAction, dispatch),
        pauseAudio: bindActionCreators(pauseAudio, dispatch),
        addToAutoQueueInfoFn: bindActionCreators(addToAutoQueueInfo, dispatch),
        seekAudioToProgressFn: bindActionCreators(seekAudioToProgress, dispatch),
        setEpisodeProgress: bindActionCreators(setEpisodeProgress, dispatch),
        // addEpisodeToRecent: bindActionCreators(addEpisodeToRecent, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayMain)
